import React, { useCallback, useState } from 'react';
import { SearchInput } from '../../../components/SearchInput/SearchInput';
import Spinner from '../../../components/Spinner';
import './GifSearch.pcss';
import { GifResponse } from '@mm/state/controllers/GifController';
import { useGifActions } from '@mm/state/actions/GifActions';
import { debounce } from 'lodash';
import { OnClickElsewhere } from '../../../components/OnClickElsewhere/OnClickElsewhere';

type Props = {
  selectGif: (selectedGif: GifResponse) => any;
};

export const GifSearch = ({ selectGif }: Props) => {
  const gifActions = useGifActions();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [gifSearchResults, setGifSearchResults] = useState<GifResponse[]>([]);

  const fetchGifs = useCallback(
    debounce(async (query: string) => {
      const response = await gifActions.getPredictions(query);
      setIsSearching(false);

      if (response) {
        setGifSearchResults(response);
      }
    }, 330),
    [],
  );

  const onSearchInputChange = async (searchInput: string) => {
    setSearchInput(searchInput);
    setIsExpanded(true);
    const query = searchInput.split(' ').join('+');

    if (searchInput) {
      setIsSearching(!!searchInput);
    }

    fetchGifs(query);
  };

  return (
    <OnClickElsewhere
      handleClick={() => setIsExpanded(false)}
      className="gif-search"
    >
      <SearchInput
        placeholder="Enter a search term..."
        hasBorder={true}
        onChange={event => onSearchInputChange(event.target.value)}
        value={searchInput}
      />

      {searchInput && isExpanded && (
        <div className="gif-search__gif-search-list">
          {isSearching ? (
            <Spinner
              show={true}
              size={40}
              position="relative"
              backgroundColor="transparent"
              className="page-selector-pane__spinner"
            />
          ) : (
            <>
              {!gifSearchResults.length && (
                <div className="page-selector-pane__no-page-text">
                  No matches for search: {searchInput}
                </div>
              )}

              {gifSearchResults.map(gifResult => (
                <div
                  onClick={() => selectGif(gifResult)}
                  className="gif-search__gif-result-item"
                  key={gifResult.id}
                >
                  <img
                    src={gifResult.images.fixedWidth.url}
                    className="gif-search__gif-result-image"
                  />
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </OnClickElsewhere>
  );
};
